<template>
  <div>
    <CCard>
      <CCardBody>
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Search"
                style="border-radius: 3rem"
              ></b-form-input>
            </div>
          </div>
        </div>

        <b-table
          class="myTable"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          show-empty
          sort-icon-left
          responsive="sm"
        >
                              <template v-slot:cell(product)="data" >
                                <td>
                                  {{data.item.product | truncate(15, "..")}}
                                </td>
                              </template>
                              <template v-slot:cell(category)="data" >
                                <td>
                                  {{data.item.category.join()| truncate(20, "..")}}
                                </td>
                              </template>

        </b-table>
        <div class="mat-table__bottom">
          <span style="margin-right: 20px; margin-bottom: 15px">
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
            ></b-form-select>
          </span>
          <span class="">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              pills
            ></b-pagination>
          </span>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import Vue from "vue";
import firebase from "firebase";
import { uuid } from "vue-uuid";
import { BootstrapVue } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);

export default {
  name: "abandonedCart",
  data() {
    return {
      items: [],
      datavalue: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      filter: "",
      fields: [
        { key: "name", label: "Name", sortable: true, sortDirection: "desc" },
        {
          key: "product",
          label: "Product",
          sortable: true,

        },
        {
          key: "category",
          label: "Category",
          sortable: true,

        },
        {
          key: "catalog",
          label: "Catalog",
          sortable: true,
                    class: "text-center",

        },
        {
          key: "quantity",
          label: "No. of Quantity",
          sortable: true,
                    class: "text-center",

        },
      ],
    };
  },

  methods: {
    getAbandonedList() {
      const db = firebase.firestore();
      let temp = 0;
      let self = this;
      db.collection("Cart")
        .where("shopID", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            // console.log("sdadad");
            this.datavalue = {
              quantity: doc.data().quantity,
            };
            console.log(doc.data().UID);
            db.collection("users")
              .where("id", "==", doc.data().UID)
              .get()
              .then((snapshot) => {
                snapshot.forEach((doc1) => {
                  db.collection("products")
                    .doc(doc.data().itemID)
                    .get()
                    .then((snapshot) => {
                      this.items.push({
                        name: doc1.data().nickname,
                        quantity: doc.data().quantity,
                        product: snapshot.data().name,
                        category: snapshot.data().category,
                        catalog: snapshot.data().catalog,
                      });
                      this.totalRows=this.items.length
                    });
                });
              });
          });

          console.log("over");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getAbandonedList();
  },
};
</script>
<style>
.myTable thead {
  font-weight: 600;
  font-family: "Montserrat";
  font-size: 18px;
  color: #3b4859;
}
.custom-select-sm {
  font-family: "Montserrat";
}
.myTable td {
  color: #3b4859;
  font-family: "Assistant";
  font-weight: 500;
  font-size: 14px;
  padding-top:5px !important;
  padding-bottom:5px !important;
}
.mat-table__bottom {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.b-pagination-pills .page-item .page-link {
  color: #3b4859;
  border: transparent;
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 400;
}
.page-item.active .page-link {
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 400;
  background: #ff0000;
  color: #fff;
  border: #ff0000;
}
.table td{
  padding: 0;
    vertical-align:0;
    border-top: none;
    border-top-color: none;
}
</style>
